<!-- Loading state -->
<div *ngIf="loading" class="auth-loading">
  <mat-spinner diameter="40"></mat-spinner>
  <p>Creating your account…</p>
</div>

<!-- Register card — single-column, max-width 480px -->
<mat-card *ngIf="!loading" class="auth-card">
  <mat-card-header>
    <mat-card-title>Create your account on Capiche</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <!-- Cheapest fix for cold-traffic context (referral links, social shares): name
         Capiche in the title above, and give a low-commitment out to anyone who
         landed here without knowing what Capiche is, before asking them to sign up.
         Deliberately just a link, not an inline explainer — a fuller "who invited
         you + what is Capiche" experience is a bigger piece of work (see referral
         email spec section 09), this is the minimal version of it. -->
    <p class="auth-context-line">
      New to Capiche? <a href="https://capiche-limited.com" target="_blank" rel="noopener">Learn more.</a>
    </p>
    <capiche-auth-login-form
      msg="{{ msg }}"
      [requireAcceptTermsOfUse]="true"
      (formData)="register($event)"
    ></capiche-auth-login-form>
  </mat-card-content>

  <mat-divider></mat-divider>

  <mat-card-actions class="auth-nav-links">
    <span>Already have an account? <a [routerLink]="['/auth/login']">Sign in</a></span>
  </mat-card-actions>
</mat-card>
